<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>마이페이지</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">마이페이지</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">서비스 이용내역</p>
          <ul class="depth">
            <li><router-link to="/mypagemain" title="회원정보">회원정보</router-link></li>
            <li><router-link to="/mypageprepayment" title="서비스 이용내역">서비스 이용내역</router-link></li>
            <li><router-link to="/mypagediscountpayment" title="웹 선불권 이용내역">웹 선불권 이용내역</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">서비스 이용내역</h3>
        <div id="tabs">
          <ul class="tabMenu">
            <li><router-link to="/mypageprepayment" title="사전결제">사전결제</router-link></li>
            <li><router-link to="/mypagepayment" title="정기권">정기권</router-link></li>
            <li class="active"><router-link to="/mypageunpaid" title="미납요금">미납요금</router-link></li>
          </ul>
          <section class="tabCont">
            <article>
              <div class="selectOpt">
                <dl>
                  <dt>차량번호</dt>
                  <dd>
                    <input maxlength="10" type="text" title="차량번호 입력" class="small" v-model="carNo" @keydown.enter="getList" />
                  </dd>
                </dl>
                <dl>
                  <dt>이용기간</dt>
                  <dd>
                    <date-picker :propsDate="searchDate" class="middle"></date-picker>
                    <button type="button" class="btn dkGray" @click="getList">조회</button>
                  </dd>
                </dl>
              </div>
              <p class="info">차량번호 전체를 입력해주세요(예:123가5678)</p>
            </article>
            <article>
              <div class="scroll-table">
                <i class="v-scroll"></i>
                <div class="table vertical-table">
                  <table>
                    <caption>
                      미납요금 이용내역 테이블
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col">순번</th>
                        <th scope="col">차량번호</th>
                        <th scope="col">주차장</th>
                        <th scope="col">이용시간</th>
                        <th scope="col">미납요금</th>
                        <th scope="col">가산금</th>
                        <th scope="col">결제금액</th>
                        <th scope="col">결제일</th>
                        <!-- <th scope="col">비고</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="nodate" v-if="nodata">
                        <td colspan="8" v-if="isLoading"><loading-spinner></loading-spinner></td>
                        <td colspan="8" v-else>조회된 데이터가 없습니다.</td>
                      </tr>
                      <tr v-else v-for="(item, index) in dataList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.carNo }}</td>
                        <td>{{ item.parkingName }}</td>
                        <td>{{ item.inDttm }} ~ {{ item.outDttm }}</td>
                        <td>{{ item.unpaidAmt }}</td>
                        <td>{{ item.addAmt | comma }}</td>
                        <td>{{ item.receiptSummary.receiptAmt | comma }}</td>
                        <td>{{ item.lastReceiptDttm }}</td>
                        <!-- <td>-</td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </article>
          </section>
        </div>
      </div>
    </section>

    <!-- 알럿 -->
    <alert-notmatch v-show="showModalMsgFailure">
      <template #content>
        <p>{{ modalMsg }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="CloseBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-notmatch>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import DatePicker from '../../../components/DatePicker2.vue';
import AlertNotmatch from '../../../components/Alert02.vue';
import LoadingSpinner from '../../../components/LoadingSpinner.vue';
import moment from 'moment';

export default {
  data() {
    return {
      showModalMsgFailure: false,
      modalMsg: '',

      carNo: '',
      nodata: true,
      dataList: [],
      searchDate: {
        startDate: moment(new Date()).format('YYYY-MM-DD'),
        endDate: moment(new Date()).format('YYYY-MM-DD'),
      },
      isLoading: false,
    };
  },

  components: {
    DatePicker,
    AlertNotmatch,
    LoadingSpinner,
  },

  methods: {
    CancleBtn() {
      this.showModalMsgFailure = false;
    },

    CloseBtn() {
      this.showModalMsgFailure = false;
    },

    validateSearchUnpaid() {
      const carNoRegex = /^\s*([가-히]{2}){0,1}\s*[0-9]{2,3}[\s]*[가-히]{1}[\s]*[0-9]{4}\s*$/gi;
      const carNoRegexDipl = /^\s*([외교,영사,준외,협정,국기,준영,대표]{2}){0,1}\s*[0-9]{3}[\s]*[-]{1}[\s]*[0-9]{3}\s*$/gi;
      if (this.carNo == '' || !(carNoRegex.test(this.carNo) || carNoRegexDipl.test(this.carNo)) ) {
        this.modalMsg = '차량번호 형식에 맞지 않습니다.';
        this.showModalMsgFailure = true;
        return false;
      }
      return true;
    },

    async getList() {
      this.isLoading = true;
      if (!this.validateSearchUnpaid()) {
        this.isLoading = false;
        return;
      }
      const res = await axios('get', '/api/unpaid/searchUnpaidList.json', {
        carNo: this.carNo,
        myPage: 'Y',
        startDate: this.searchDate.startDate,
        endDate: this.searchDate.endDate,
      });
      const data = res.data.value.result;
      if (!data) {
        this.nodata = true;
        this.isLoading = false;
        return;
      }

      this.dataList = data;
      this.nodata = false;
      this.isLoading = false;
    },
  },
};
</script>
